import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/web.dom.iterable";
import UrlParse from 'url-parse';
import { CDN_PRISMIC_DEPRECATED, CDN_PRISMIC, CDN_MDM, MEDIA_PATH } from '~/const/images';

function formatImage(imageUri, formats, folder) {
  const datas = {};
  Object.entries(formats).forEach(arr => {
    const pathImage = {};
    pathImage[arr[0]] = "//www.maisonsdumonde.com/uploads/".concat(folder, "/").concat(arr[1], "/").concat(imageUri, " ").concat(arr[1], "w");
    Object.assign(datas, pathImage);
  });
  return datas;
}

function formatImageCloudinary(imageUri) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let defaultParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'q_auto,f_auto';
  let folder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'image';

  if (!imageUri) {
    return '';
  }

  return ["".concat(MEDIA_PATH, "/").concat(folder, "/upload"), defaultParams, ...params, new UrlParse(imageUri).pathname.substr(1)].join('/');
}

function formatPrismicImage(imageUri, params, defaultParams) {
  let folder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'image';
  let newUri = '';

  if (imageUri) {
    // Check if prismic media come from old URL
    const regex = /(\W|^)images\.prismic.io(\W|$)/g;

    if (!imageUri.match(regex)) {
      newUri = imageUri.replace(CDN_PRISMIC_DEPRECATED, "//".concat(CDN_MDM, "/prismic/"));
    } else {
      newUri = unescape(imageUri).replace(CDN_PRISMIC, "//".concat(CDN_MDM, "/prismic-imgix/"));
    }
  }

  return formatImageCloudinary(newUri, params, defaultParams, folder);
}

export { formatImage, formatImageCloudinary, formatPrismicImage };